const digestDropdownToggle = (bucketDate, toggle) => {
  if (toggle === 'show') {
    document
      .querySelector(`[data-single-tile-digest="${bucketDate}"]`)
      .children[0].classList.add('active_menu');
  } else {
    document
      .querySelector(`[data-single-tile-digest="${bucketDate}"]`)
      .children[0].classList.remove('active_menu');
  }
};

const menuButtonBase = (type, icon, handleAction, tile) => ({
  attrs: {
    className: `${type === 'copy' ? 'duplicate' : type}_title`,
    style: { width: '100%' },
  },
  icon,
  text: type
    .split('-')
    .map(word => word.replace(/^\w/g, char => char.toUpperCase()))
    .join(' '),
  clickEvent: () => {
    handleAction(tile);
  },
});

const renderDigestMenuButtons = ({
  createTile,
  editDigest,
  deleteDigest,
  bucketDate,
}) => {
  const result = [
    menuButtonBase('create-tile', 'fa-solid fa-plus', createTile, bucketDate),
    menuButtonBase('edit-digest', 'fa-regular fa-gear', editDigest, bucketDate),
    menuButtonBase(
      'delete-digest',
      'fa-regular fa-trash-can',
      deleteDigest,
      bucketDate,
    ),
  ];

  return result;
};

export { renderDigestMenuButtons, digestDropdownToggle };
